module.exports = __webpack_public_path__ + "static/img/fun2.74e12419.png";